// app/frontend/pages/Onboarding/steps/StepWelcome.tsx
import { Stack, Box } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";
import { StepShell } from "../../../components/ui/Stepper";
import { L2KText } from "../../../components/ui/Typography";
import type { StepComponentProps } from "../../../components/ui/Stepper";
import type { OnboardingFormValues } from "../types";

export function StepWelcome({}: StepComponentProps<OnboardingFormValues>) {
  return (
    <StepShell
      title="Welcome to Learntokiz!"
      subtitle="Let's personalize your experience"
    >
      <Stack gap="lg" align="center" py="md">
        <Box
          style={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(255, 152, 0, 0.2), rgba(255, 87, 34, 0.2))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid rgba(255, 152, 0, 0.3)",
          }}
        >
          <IconSparkles size={40} color="#FF9800" />
        </Box>

        <Stack gap="xs" align="center">
          <L2KText ta="center">
            We'll ask you a few quick questions to customize your learning journey.
          </L2KText>
          <L2KText variant="secondary" ta="center" size="sm">
            This only takes about 30 seconds.
          </L2KText>
        </Stack>
      </Stack>
    </StepShell>
  );
}

export default StepWelcome;
